// Supports weights 100-900
import '@fontsource-variable/noto-serif';
// Supports weights 100-900
import '@fontsource-variable/noto-sans-jp';

// this code is to add google analytics to site:
export const onClientEntry = () => {
  // Initialize dataLayer first
  window.dataLayer = window.dataLayer || [];

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-EM1L0ZPNQX'; // Your actual ID

  script.onload = () => {
    // This runs after the script loads
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'G-EM1L0ZPNQX'); // Your actual ID
  };

  document.head.appendChild(script);
};
